import { Stack, Typography } from '@mui/material';
import styled from 'styled-components';

import { PageWrapper } from '@shared/styledComponents';
import { colorTheme, extraColor } from './muiTheme';

export const FlexEnd = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const FormFooter = styled(FlexEnd)`
  margin-top: 40px;
`;

export const Row = styled.div<{ gap?: string; justify?: string; flexWrap?: string }>`
  display: flex;
  align-items: center;
  gap: ${({ gap }) => gap || '5px'};
  margin-bottom: 5px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  ${({ justify }) =>
    justify &&
    `
    justify-content: ${justify};
  `}

  ${({ flexWrap }) =>
    flexWrap &&
    `
  flex-wrap: ${flexWrap};
  `}

  span {
    display: inherit;
    gap: 5px;
  }
`;

export const ModalWrapper = styled.div`
  padding: 10px 15px;
`;
export const BoxWraper = styled.div`
  padding: 24px;
  padding-top: 0px;
  height: 63vh;
  background-color: ${colorTheme.palette.secondary.light};
  margin-top: 12px;
  overflow-y: auto;
`;
export const ButtonWraper = styled.div`
  margin-top: 10px;
  float: right;
  display: flex;
  justify-content: end;
`;
export const RadioButtonWrapper = styled.div`
  padding-top: 15px;
  padding-bottom: 15px;
  margin-top: 0px !important;
`;

export const DealBuilderHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const DealBuilderBody = styled.div`
  padding: 12px 15px;
  background: ${colorTheme.palette.secondary.light};
  min-height: 77px;
  margin-bottom: 35px;
  border-radius: 8px;
  display: flex;
  gap: 10px;
  justify-content: space-between;
`;

export const DealBuilderBodySection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const DealBuilderLabel = styled(Typography)`
  color: ${colorTheme.palette.common.black};
  font-weight: bold;
`;

export const DealBuilderActions = styled.div`
  gap: 5px;
  display: flex;
  color: ${({ theme: { palette } }) => palette.success.main};
  align-items: center;

  .Mui-checked {
    color: inherit;
  }

  .MuiFormControlLabel-label {
    color: ${({ theme }) => theme.palette.primary.dark};
  }
`;

export const Flex = styled.div`
  display: flex;
  align-items: left;
  gap: 5px;
  margin-top: 5px;
`;

export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
`;

export const ExpandedDealsWrapper = styled.div`
  && {
    padding-left: 80px;
    overflow-y: auto;
    max-height: 35vh;
    
  ::-webkit-scrollbar {
    width: 0.2em;
  }

  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px ${extraColor.palette.grey.light};
  }
   
  ::-webkit-scrollbar-thumb {
    background-color: ${extraColor.palette.grey.main};
  }

    .MuiDataGrid-detailPanel {
      color: ${colorTheme.palette.common.black};
      padding-left: 50px;
    }

    .MuiDataGrid-cell {
      color: ${colorTheme.palette.common.black};
    }
  }
`;

export const LenderWrapper = styled.div`
  gap: 20px;
  padding: 20px;
  display: flex;
  background: ${colorTheme.palette.success.light};
  border-radius: 8px;
  flex-direction: row;
  margin-bottom: 20px;
`;

export const ModalHeader = styled.div`
  color: ${colorTheme.palette.common.white};
  width: 100%;
  padding: 20px;
  border-radius: 15px;
  background: transparent linear-gradient(270deg, ${colorTheme.palette.primary.dark} 0%, ${colorTheme.palette.primary.light} 100%) 0% 0% no-repeat padding-box;
`;

export const ConditionsSection = styled.div<{ bg?: string }>`
  padding: 20px 15px;
  background: ${({ bg }) => bg || 'transparent'};
`;

export const FieldGroup = styled.div`
  display: flex;
  align-items: center;

  button {
    margin-right: -5px;
  }
`;

export const GridItemsWrapper = styled.div`
  .MuiGrid-container .MuiGrid-item:nth-child(n+3) {
    padding-top: 0;
  }
`;

export const FormControl = styled.div<{ bold?: boolean }>`
  gap: 10px;
  height: 30px;
  display: flex;
  font-size: 14px;
  line-height: 1.3;
  margin-bottom: 10px;
  align-items: center;
  justify-content: space-between;

  .MuiInputBase-root {
    border-radius: 4px;
    padding-right: 5px;

    fieldset,
    &.Mui-disabled fieldset {
      border-color: transparent;
    }
  }

  & > div {
    width: 50%;
    min-width: 50%;
  }
`;

export const CoBorrowerControls = styled.div`
  display: flex;
  gap: 50px;
  align-items: center;
  margin-bottom: 30px;
`;

export const ControlGroup = styled.div`
  display: flex;
  gap: 10px;
  width: 330px;
  align-items: center;
`;

export const CoBorrowerWrapper = styled.div`
  font-size: 14px;
  border-radius: 8px;
  padding: 15px 20px;
  gap: 15px 0;
  margin: 22px 0;
  background: ${extraColor.palette.green.light};
  display: flex;
  flex-wrap: wrap;
`;

export const CoBorrowerSection = styled.div`
  min-width: 20%;
  max-width: 20%;
  display: flex;
  flex-direction: column;
  white-space: pre;
  gap: 10px;
`;

export const FormContainer = styled.div`
  && {
    background: ${colorTheme.palette.secondary.light};
    border-radius: 8px;
    overflow: hidden;
  }
`;

export const FormWrapper = styled.div`
  padding: 10px;
`;

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ButtonsContainer = styled.div`
  justify-content: flex-end;
  display: flex;
  margin-top: 20px;
`;

export const FormRow = styled.div`
  display: flex;
  margin-top: 30px;
`;
export const ContactDetailsWrapper = styled.div`
  flex: 1;
  display: flex;
  width: 100%
  background: transparent linear-gradient(270deg, var(--blue-dark) 0%, var(--blue-light) 100%) 0% 0% no-repeat padding-box;
  background: transparent linear-gradient(270deg, ${colorTheme.palette.primary.dark} 0%, ${colorTheme.palette.primary.light} 100%) 0% 0% no-repeat padding-box;

  .btn-border {
    border: 1px solid ${colorTheme.palette.info.light};
  }
`;

export const WithoutOverlappingDiv = styled.div`
  max-width: 95%;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const SectionContainer = styled.div`
  font-size: 16px;
  font-weight: 700;
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  justify-content: space-between;
`;

export const Content = styled.div`
  padding: 25px;

  .MuiFormControlLabel-root {
    height: auto;
    width: 100%;
  }

  p {
    display: flex;
    justify-content: space-between;
  }

  .bordered {
    border-right: 1px solid ${colorTheme.palette.secondary.main};
    padding-right: 25px;
  }
`;

export const WithBG = styled.div`
  background: ${colorTheme.palette.secondary.light};
  padding: 20px 15px;
  font-weight: 700;
  border-radius: 8px;
  margin-bottom: 20px;
`;
export const TileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 35px 0 0 20px;
  gap: 14px;
`;

export const ContactManagerWrapper = styled.div`
  display: flex;
  flex-direction: column;

  ${PageWrapper} {
    display: flex;
  }
`;

export const LoaderWrapper = styled.div`
  display: flex;
  flex: 2;
  align-items: center;
  justify-content: center;
`;

export const RolesContainer = styled.div`
  display: flex;
  height: 100%;
  gap: 24px;
`;

export const ReadytoShipFooter = styled.div<{ justify?: string }>`
  display: flex;
  gap: 40px;
  align-items: center;
  justify-content: ${({ justify }) => justify || 'flex-end'};
  margin-bottom: 15px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
`;
export const TreeViewWrapper = styled.div`
  flex: 0 0 40%;
`;

export const AvoidPageBreakInsideWrapper = styled.div`
  page-break-inside: avoid;
  break-inside: avoid;

  .MuiDataGrid-cell{
    height: auto !important;
  }

  .MuiDataGrid-row {
    height: auto !important;
  }

  .MuiDataGrid-columnHeader: first-child, .MuiDataGrid-cell:first-child {
    padding: 0 0 0 10px !important;
    width: 100px !important;
  }
`;

export const ExcludedStatesColumn = styled.div`
  min-width: 248px;
  height: calc(100% - 42px);
  flex: 1;

  .MuiDataGrid-root {
    margin: 0;
  }

  .MuiDataGrid-footerContainer {
    display: none;
  }
`;

export const IncludedItems = styled.div`
  width: 100%;
  overflow: auto;
`;

export const HorizontalScrollStyle = styled.div`
&& {
  
  .MuiDataGrid-virtualScroller::-webkit-scrollbar {
    height: 0.4em;
  }

  .MuiDataGrid-virtualScroller::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px ${extraColor.palette.grey.light};
  }
 
  .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb:horizontal{
    background-color: ${extraColor.palette.grey.main};
  }
}
`;

export const FieldDivWrapper = styled.div`
  position: relative;
  top: -32px;
  left: 51%;
  background: ${colorTheme.palette.secondary.main};
  width: 130px;
  height: 30px;
  padding: 8px;
  borderRadius: 3px;
`;

export const LenderUtilityController = styled(Stack)`
   background-color: ${extraColor.palette.blue.light};
   padding: 8px 12px;
   border-radius: 8px;
   justify-content: space-between
   margin: 0 auto 0 1rem;
`;